module.exports = __webpack_public_path__ + "static/media/4ODA16.2415bdf3.jpg";